import { render, staticRenderFns } from "./RiskModelResult.vue?vue&type=template&id=4344ad99&scoped=true&"
import script from "./RiskModelResult.vue?vue&type=script&lang=js&"
export * from "./RiskModelResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4344ad99",
  null
  
)

export default component.exports